import React from "react";
import { Form } from "react-bootstrap";

import classNames from "classnames";

import { useGameSummaryContext } from "../contexts/GameSummary";

import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { displayFormAlert } from "../../../../../lib/utils";

const ClubhouseGameSummary = (): React.JSX.Element => {
    const { game, methods } = useGameSummaryContext();
    const team = useAppSelector(selectSelectedTeam);

    const summary =
        game.home.id === team?.id ? "homeSummary" : "visitorSummary";
    const watchSummary =
        summary === "homeSummary"
            ? methods.watch("homeSummary")
            : methods.watch("visitorSummary");

    return (
        <section className="gameSummary" data-testid="gameSummary">
            <Form.Group controlId={summary}>
                <Form.Label className={classNames("mt-0 h3")}>
                    Game Summary
                </Form.Label>
                <Form.Text className={classNames("d-block mb-2")}>
                    <strong>
                        Please detail outstanding performances and game
                        highlights. This game summary will be available to be
                        viewed by the public on the Team Schedule Page.
                    </strong>
                </Form.Text>
                <Form.Control
                    as="textarea"
                    rows={8}
                    maxLength={500}
                    {...methods.register(summary)}
                />
                {watchSummary?.length === 500 &&
                    displayFormAlert({
                        level: "danger",
                        text: "Summary is limited to 500 characters",
                    })}
            </Form.Group>
        </section>
    );
};

export default ClubhouseGameSummary;
